export function listTimetableBySchoolClassAndShift(schoolId, shiftId) {
  const mutation = `{
    timetableListBySchoolClassAndShift( 
        schoolClass: {
            id: ${schoolId}
            studentsQuantity: 0,
            filterByStatus: false,
            updaterId: 0, 
            year: 0,
            active: true,
            capacity: 0
            }, 
            shift: {
                id: ${shiftId},
                filterByStatus: false, 
                updaterId: 0,
                active: true
            })
        {
         id,
         schoolClass{
             id,
            name
         },
         subject{
             id,
            name,
            label,
            value,
         },
         professor{
             id,
            name,
            label,
            value,
         },
         shift{
             id,
            name,
         },
         room{
             id,
            name,
            label,
            value,
         },
         items{
             id,
             shiftItem{
                 id,
                 sequence,
                 displaySequence,
                 startAt,
                 endAt,
                 type
             }
         }
        }
}
`;
  return mutation;
}

export function saveTimetableMutation(schoolClassId, values) {
  const shiftItemsBySubject = {};
  values.cardsSubjects.forEach((card) => {
    const array = [];
    Object.keys(values.timetable).forEach((day) => {
      values.timetable[day].forEach((item) => {
        if (
          item.shiftItem.card.subject &&
          item.shiftItem.card.subject.id === card.subject.id
        ) {
          array.push({
            itemId: item.id,
            weekday: Number(day),
            id: item.shiftItem.id,
            sequence: item.shiftItem.sequence,
            displaySequence: item.shiftItem.displaySequence,
            startAt: item.shiftItem.startAt,
          });
        }
      });
      shiftItemsBySubject[card.subject.id] = array;
    });
  });

  const cardsSubjects = values.cardsSubjects.map((card) => {
    return {
      id: card.id || 0,
      schoolClass: {
        id: schoolClassId,
        name: values.name,
        studentsQuantity: 0,
        filterByStatus: false,
        updaterId: 0,
        year: 0,
        active: true,
        capacity: 0,
      },
      subject: {
        id: card.subject.id,
        name: card.subject.name,
        termFilterId: 0,
        filterByStatus: false,
        updaterId: 0,
        subjectLevelFilterId: 0,
        active: true,
      },
      professor: {
        id: card.professor.id,
        name: card.professor.name,
        usuarioChatInterno: false,
        ativo: true,
        filterByStatus: false,
        pedagogicAdm: false,
        updaterId: 0,
        active: true,
        usuarioChat: false,
      },
      room: {
        id: card.room.id,
        name: card.room.name,
        filterByStatus: false,
        updaterId: 0,
        active: true,
        capacity: 0,
      },
      shift: {
        id: values.classShift.id,
        filterByStatus: false,
        updaterId: 0,
        active: true,
      },
      items: shiftItemsBySubject[card.subject.id]
        ? shiftItemsBySubject[card.subject.id].map((item) => {
            return {
              id: item.itemId || 0,
              weekday: item.weekday,
              shiftItem: {
                id: item.id,
                sequence: item.sequence,
                displaySequence: item.displaySequence,
                startAt: item.startAt,
              },
            };
          })
        : [],
    };
  });

  const mutation = `
  mutation{
    timetableSaveAll( 
      listOfTimetable: ${JSON.stringify(cardsSubjects).replace(
        /"([^(")"]+)":/g,
        '$1:'
      )}     
    )
    {id}
}`;
  return mutation;
}

export function timetableListBySchoolClass(schoolId, courseStep, classShiftId) {
  const query = `{
    timetableListBySchoolClass(
    schoolClass: {
        id: ${schoolId},        
        courseStep: ${JSON.stringify(courseStep).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )} 
        classShift: {
            id: ${classShiftId}
            filterByStatus: false,
            updaterId: 0,
            active: true
        }
        studentsQuantity: 0,
        filterByStatus: false,
        updaterId:0,
        year:0,
        active:true,
        capacity:0,        
    })
    {
        id    
        subject {
            id
            name
            value
            label
        }
        professor {
            id,
            name,
            label,
            value
        },
        room {
            id,
            name,
            label,
            value
        },   
        items {
            id
            shiftItem {
                id
                sequence
                displaySequence
            }
        } 
    }
}`;
  return query;
}

export function findCurriculumByCouseStepWithWorkLoad(courseStep) {
  const query = `{
    findCurriculumByCouseStepWithWorkLoad(
         courseStep: ${JSON.stringify(courseStep).replace(
           /"([^(")"]+)":/g,
           '$1:'
         )} 
    )
    {
      subject {
          id
          name
          value
          label
      },
      stepWorkLoad
    }
}`;
  return query;
}

export function timetableGridBySchoolClass(
  schoolId,
  courseStep,
  academicCalendarId,
  classShiftId
) {
  return `{
    timetableGridBySchoolClass(
    schoolClass: {
        id: ${schoolId},        
        courseStep:  ${JSON.stringify(courseStep).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        academicCalendar: {
            id: ${academicCalendarId}
        },
        classShift: {
            id: ${classShiftId}
            filterByStatus: false
            updaterId: 0
            active: true
        }
        studentsQuantity: 0,
        filterByStatus: false,
        updaterId:0,
        year:0,
        active:true,
        capacity:0,        
    })
    {
        weekDay    
        items {
            id
            timetable {
                id,
                subject {
                    id,
                    name,
                },
                professor {
                    id,
                    name, 
                },
            }
            shiftItem {
                id,
                sequence,
                displaySequence,
                startAt,
                endAt,
                type,
                shiftId
            }
        }
    }
}`;
}
